import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = {
  value: '',
  disabled: "",
  selected: ""
}
const _hoisted_3 = { value: 0 }
const _hoisted_4 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("select", {
      class: "form-control input-sm custom-select",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeCompany($event)))
    }, [
      _createElementVNode("option", _hoisted_2, _toDisplayString(_ctx.$t('selectCompany')), 1),
      _createElementVNode("option", _hoisted_3, _toDisplayString(_ctx.$t('all')), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
        return (_openBlock(), _createElementBlock("option", {
          key: item.id,
          value: item.id
        }, _toDisplayString(item.name), 9, _hoisted_4))
      }), 128))
    ], 32)
  ]))
}